/**
 * Public entry point for `@ozankurt/context-menu`.
 *
 * The runtime surface is `ContextMenu` and `createContextMenu`; `Registry` and
 * the renderer are exported because an adapter or a consumer with an unusual
 * host may want the pieces rather than the whole. The framework adapters live
 * behind their own entries (`/react`, `/vue`, `/jquery`).
 */

// Extracted by the build into `dist/styles.css`, which the package `exports`
// map publishes as `@ozankurt/context-menu/styles.css`. The import is removed
// from the emitted JavaScript, so nothing is injected into a consumer that
// wants to ship its own stylesheet.
import './styles/context-menu.css'

export { ContextMenu, createContextMenu } from './core/ContextMenu'
export type { EmitterEvent, Listener } from './core/Emitter'
export { Registry } from './core/Registry'
export type { RegistryMatch } from './core/Registry'
export { renderError, renderLoading, renderMenu } from './core/Renderer'
export type { RenderOptions } from './core/Renderer'

export type {
  Action,
  BaseItem,
  CloseReason,
  ContextMenuOptions,
  Ctx,
  EventName,
  EventPayload,
  Item,
  ItemsResolver,
  Labeller,
  MenuDefinition,
  Meta,
  Predicate,
  ResolvedItem,
} from './core/types'

/** The package version, injected at build time from package.json. */
export const VERSION: string = __CTX_VERSION__
